module.exports = __webpack_public_path__ + "static/img/waikuang.6277745a.png";